import { createContext } from 'react';
import { MyAccountKeyAndValue } from '../types';

export type AccountCtx = {
  showDeleteAccountConfirmAlert: boolean;
  showDeleteAccountErrorAlert: boolean;
  showDeleteAccountSuccessAlert: boolean;
  showDeleteBillingConfirmAlert: boolean;
  showChangeDefualtOperational: boolean;
  showChangeDefualtBilling: boolean;
  showChangeDefualtOperationalSuccessfull: boolean;
  showChangeDefualtBillingSuccessfull: boolean;
  showAddTypeOfOperational: boolean;
  showAddTypeOfBilling: boolean;
  showAddOperational: boolean;
  showAddBilling: boolean;
  showAddOperationalSuccessfull: boolean;
  showAddBillingSuccessfull: boolean;
  accontNumber: string;
  accountType: string;
  accountName: string;
  currency: string;
  selectableAccounts: MyAccountKeyAndValue[];
  deleteAccountError: string;
  token: string;
  selectionChanged: (token: string) => void;
  paymentMehtod: string;
  paymentMethodChanged: (type: string) => void;
};

const AccountContext = createContext<AccountCtx>({
  showDeleteAccountConfirmAlert: false,
  showDeleteAccountErrorAlert: false,
  showDeleteAccountSuccessAlert: false,
  showDeleteBillingConfirmAlert: false,
  showChangeDefualtOperational: false,
  showChangeDefualtBilling: false,
  showAddOperational: false,
  showAddBilling: false,
  showChangeDefualtOperationalSuccessfull: false,
  showChangeDefualtBillingSuccessfull: false,
  showAddOperationalSuccessfull: false,
  showAddBillingSuccessfull: false,
  showAddTypeOfOperational: false,
  showAddTypeOfBilling: false,
  accontNumber: '',
  accountType: '',
  accountName: '',
  currency: '',
  selectableAccounts: [],
  deleteAccountError: '',
  token: '',
  selectionChanged: () => {},
  paymentMehtod: '',
  paymentMethodChanged: () => {},
});

export default AccountContext;
